import { number, string, shape, arrayOf, func, bool, oneOfType } from 'prop-types';

export default {
  index: number.isRequired,
  item: shape({
    container: string
  }).isRequired,
  member: string.isRequired,
  goods: arrayOf(shape({
    label: string
  })),
  containers: arrayOf(shape({
    label: string,
    length: number,
    width: number,
    height: number,
    tareWeight: number
  })),
  change: func.isRequired,
  remove: func.isRequired,
  disabled: bool,
  expanded: oneOfType([string, bool]).isRequired,
  handleSetExpanded: func.isRequired
};
